
class DataItem {
  key: String;
  label: String;
  disabled: boolean;

  constructor(key = "", label = "") {
    this.key = key;
    this.label = label;
  }
}
import UserAssignment from "@/store/modules/system/userassignment/entity";
import { Component, Mixins, ActionButtonConfig, FormModalMixins} from "@/lib";
@Component({
})
export default class CreateUserAssignment extends Mixins(FormModalMixins) {
    
    model: UserAssignment = new UserAssignment();
    modalData: any = {
    customerIds: Array<DataItem>(),
  };
    async created(){
        Object.assign(this.config, {modelTitleL: "Action.Add",labelWidth:100, okAction:"system/userassignment/create"});
         await this.$store.dispatch("system/userassignment/getUser");
    }
    methods(){
        // (this.$refs["form-modal"] as any).resetFields();
    }
    get userList() {
    return this.$store.state.system.userassignment.userList;
  }
    get customerList() {
    return this.$store.state.system.userassignment.customerList;
  }
  onChange(newTargetKeys) {
    this.modalData.customerIds = newTargetKeys;
    this.model.customerIdList=this.modalData.customerIds;
    (this.$refs["form-modal"] as any).validateField("customerIdList");
  }
  resetModel(){
    this.model = new UserAssignment();
  
  }
  invoiceRatioValidator(){
    return [
      {
        required: true, //是否必填
        type: "array",
        min: 1,
        message: this.L("Validate.PleaseSelect", this.L('app.CustomsDeclarationElement.Element')), //验证信息
        trigger: "change" //触发方式    常用  blur 和 change}
      }
    ]
     
  }
 async getcustomer(value){
   await this.$store.dispatch("system/userassignment/getCustomer",{id:value});

  }
  close(){
       this.config.isShow = false;
       this.modalData.customerIds=new Array<DataItem>();
       this.model = new UserAssignment();
       this.$store.state.system.userassignment.customerList=new Array();
  }
  
    
}
